import { ANY_RESOURCE_KIND, type WindowDescriptor } from '@krp/client-runtime'

import type { DuplicatesUiState } from '../reducer'

/** Окна пакета: адрес, подпись, место в меню и разделе — один раз (R11). Содержимое окна — binding приложения. */
export const DUPLICATES_WINDOWS = {
  home: 'duplicates.home',
  source: 'duplicates.source',
} as const

export const DUPLICATES_SECTION = 'duplicates'

/** Право Platform «Дубли: поиск и разбор»: без него пункта в меню нет; сервер всё равно проверяет его на каждой ручке. */
export const DUPLICATES_USE = 'platform:duplicates:use'

/** Право на источник: служба дублей читает его наименования по `catalog.read`. */
export const DUPLICATES_SOURCE_CAPABILITY = 'catalog.read'

export const duplicatesWindows: readonly WindowDescriptor<DuplicatesUiState>[] = [
  {
    // Вход раздела — выбор источника плитками; раздел сам вкладку не открывает.
    kind: DUPLICATES_WINDOWS.home,
    scope: 'global',
    paths: ['/duplicates'],
    label: 'Дубли',
    menu: { group: 'work', order: 45, icon: 'duplicates', requires: DUPLICATES_USE },
    section: { id: DUPLICATES_SECTION, home: { pickResource: true } },
  },
  {
    // Любой источник с правом `catalog.read`: служба дублей не зависит от вида. Выбранная карточка пары — не часть вкладки (И-11).
    kind: DUPLICATES_WINDOWS.source,
    scope: 'resource',
    paths: ['/duplicates/:rid'],
    label: 'Дубли',
    section: { id: DUPLICATES_SECTION, tab: { resourceKind: ANY_RESOURCE_KIND, capability: DUPLICATES_SOURCE_CAPABILITY, label: 'Дубли' } },
  },
]
